import { AnyAction } from 'redux'
import actionTypes from './actionTypes'
import { MediaItemData } from '../../models/mediaItemData'

export const moviesLoading = (): AnyAction => ({
  type: actionTypes.loading
})

export const moviesLoadingFailed = (): AnyAction => ({
  type: actionTypes.loadingFailed
})

export const moviesLoaded = (movies: MediaItemData[]): AnyAction => ({
  type: actionTypes.loaded,
  payload: { movies }
})
